<template>
  <div>
    <div class="alert alert-danger" role="alert"  v-for="group in getErrors(fields)">
      <a v-if="!group.important"
        href="#"
        class="close"
        data-dismiss="alert"
        @click.prevent.stop="clearError([group.name])">

        &times;
      </a>

      <h5 v-if="group.name === 'UnprocessableEntity'">
        Os seguintes erros de validação foram encontrados
      </h5>

      <ul>
        <li v-for="(messages) in group.data.errors">
          <span v-for="(message, index) in messages">
            {{ message }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    props: {
      fields: {
        type: Array,
        default () { return [] }
      }
    },

    computed: {
      ...mapState('errors', {
        errors: state => state.all
      }),

      ...mapGetters({
        'getErrors': 'errors/getErrors'
      })
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/Flash.vue